import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import AllergyList from "./AllergyList";
import AllergyForm from "./AllergyForm";
import { LIST, CREATE, UPDATE } from "../../../queries/allergy.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../providers/Auth.Provider";
import { Redirect } from "react-router-dom";
import AllergyUpdateForm from "./AllergyUpdateForm";

function AllergyIndex({ match, location }) {
	// local state
	const [newAllergy, setNewAllergy] = useState(false);
	const [uAllergy, setUAllergy] = useState(null);

	const {
		LogOut,
		IsAuthenticationError,
		GetAuthenticatedStaff,
		GetToken
	} = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();
	// query;
	const { loading, error, data } = useQuery(LIST, {
		variables: { site: site && site.id }
	});
	// New
	const [
		PostCreateFunc,
		{ loading: cLoading, error: cError, data: cData }
	] = useMutation(CREATE, {
		update(caches, cb) {
			const { GetAllergies } = caches.readQuery({
				query: LIST,
				variables: { site: site && site.id }
			});
			GetAllergies.docs.unshift(cb.data.NewAllergy.doc);
			caches.writeQuery({
				query: LIST,
				data: { GetAllergies },
				variables: { site: site && site.id }
			});
		}
	});

	const [
		updateFunc,
		{ loading: iLoading, error: iError, data: iData }
	] = useMutation(UPDATE);

	/**
	 * A function that scrolls the page to top
	 */
	function scrollTop() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}
	const title = "Patient Allergies";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];
	if (error && IsAuthenticationError(error.message)) {
		LogOut();
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?redirect=${location.pathname}`
				}}
			/>
		);
	}
	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />
			<div className="row justify-content-center">
				{newAllergy && !uAllergy && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => {
											setNewAllergy(false);
											scrollTop();
											setUAllergy(null);
										}}
										title="Back"
										className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
									>
										<i className="material-icons">keyboard_backspace</i>
									</button>
									New Allergy
								</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={cLoading} />
								<AlertMessage
									message={cError && cError.message}
									failed={true}
								/>
								<AlertMessage message={cData && cData.NewAllergy.message} />

								<AllergyForm
									onCancel={() => {
										setNewAllergy(false);
										scrollTop();
										setUAllergy(null);
									}}
									onSubmit={async name => {
										await PostCreateFunc({
											variables: { name, site: site && site.id }
										});
										setTimeout(() => {
											setNewAllergy(false);
											scrollTop();
											setUAllergy(null);
										}, 500);
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{!newAllergy && !uAllergy && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Allergy List</header>
								<div className="tools">
									<button
										type="button"
										onClick={() => {
											setNewAllergy(true);
											scrollTop();
											setUAllergy(null);
										}}
										className="mdl-button mdl-button--icon btn-success"
									>
										<i className="material-icons">add</i>
									</button>
								</div>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={loading} />
								<AlertMessage message={error && error.message} failed={true} />

								{!loading && (
									<AllergyList
										items={data && data.GetAllergies.docs}
										onEdit={item => {
											setNewAllergy(false);
											scrollTop();
											setUAllergy(item);
										}}
									/>
								)}
							</div>
						</div>
					</div>
				)}

				{!newAllergy && uAllergy && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => {
											setNewAllergy(false);
											setUAllergy(null);
											scrollTop();
										}}
										title="Back"
										className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
									>
										<i className="material-icons">keyboard_backspace</i>
									</button>
									Update Allergy
								</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={iLoading} />
								<AlertMessage
									message={iError && iError.message}
									failed={true}
								/>
								<AlertMessage message={iData && iData.UpdateAllergy.message} />
								<AllergyUpdateForm
									onCancel={() => {
										setNewAllergy(false);
										setUAllergy(null);
										scrollTop();
									}}
									onSubmit={async name => {
										await updateFunc({
											variables: { id: uAllergy.id, name }
										});
										setTimeout(() => {
											setNewAllergy(false);
											scrollTop();
											setUAllergy(null);
										}, 500);
									}}
									currentValue={uAllergy.name}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
}

export default AllergyIndex;
